// extracted by mini-css-extract-plugin
module.exports = {"separator":"DropdownSeparator_separator__3vETI"};